import { LevelProps } from './tokens'
import { calcLineHeight } from '../utils'
import { DNA } from '../visual-language'

export function linkStyles({
  level = 'medium',
  isFocusVisible = true,
}: LinkStylesProps) {
  return {
    ...levelStyles[level],

    color: DNA.tokens.alias.color.primary,
    textDecorationStyle: isFocusVisible ? 'double' : 'inherit',
    outline: 'none',
  }
}

const levelStyles = {
  xlarge: {
    fontSize: DNA.tokens.dimension.font[300],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[300],
      lineHeight: 1.5,
    }),
  },
  large: {
    fontSize: DNA.tokens.dimension.font[200],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[200],
      lineHeight: 1.5,
    }),
  },
  medium: {
    fontSize: DNA.tokens.dimension.font[100],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[100],
      lineHeight: 1.5,
    }),
  },
  small: {
    fontSize: DNA.tokens.dimension.font[75],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[75],
      lineHeight: 1.5,
    }),
  },
  xsmall: {
    fontSize: DNA.tokens.dimension.font[50],
    lineHeight: calcLineHeight({
      fontSize: DNA.tokens.dimension.font[50],
      lineHeight: 1.5,
    }),
  },
}

export interface LinkStylesProps extends Partial<LevelProps> {
  /** Control if focus state is visible. */
  isFocusVisible?: boolean
}
